export default "__VITE_ASSET__CThvSnru__"